import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "material-ui/styles";
import { connect } from 'react-redux';
import Typography from "material-ui/Typography";
import MuiButton from "material-ui/Button";
import IconButton from "material-ui/IconButton";
import Button from "../../Parts/Button";
import Loader from "../../Parts/Loader";
import ArrowToolTip from "../../common/ArrowToolTip";
import SettingIcon from "../../Icons/SettingIcon";
import Thunder from "../../Icons/Thunder";
import SendLetter from "../../Icons/SendLetter";
import FollowCall from "../../Icons/FollowCall";
import { hasKLFollowCallBeenEnabled } from '../../../utils/userUtils';
import { OwnerType } from '../../../constants/ComponentTypes';
import OrderContractFilterDialog from '../dialogs/OrderContractFilterDialog';
import * as actions from '../../../redux/actions/OrderDashboard';
import { getOrderList } from '../../../redux/actions/OrderList';
import { getOrderContacts } from '../../../redux/actions/AccountSetting';
import { TimelineStatusLabelType } from '../../../constants/ComponentTypes';
import { TimelineLabelType } from "../../../constants/ComponentTypes";
import { ACTIVITIES_PER_PAGE } from "../../../constants/Constants";
import { formatName, isOrderScheduledAfter } from "../../../utils/utils";
// TODO: 日付フォーマットで使用しているだけなのでdate-fnsに置き換える
import moment from "moment";

const styles = () => ({
  root: {
    background: "#FFFFFF",
    width: "100%",
    position: "relative",
    boxSizing: "border-box",
    border: "1px solid #E7E9EB",
    boxShadow: "0px 1px 2px #0000001F",
    borderRadius: "2px",
    height: "100%",
  },

  header: {
    borderBottom: "1px solid #E7E9EB",
    display: "flex",
    alignItems: "center",
    height: "60px",
    padding: "0 20px",
    marginBottom: "10px",
    justifyContent: "space-between",
  },

  content: {
    padding: "10px 25px 60px 25px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  itemContainer: {
    width: "100%",
    boxSizing: "border-box",
    marginBottom: "20px",
  },

  rect: {
    width: "4px",
    height: "20px",
    background: "#E7E9EB",
    transform: "translateX(25px)",
  },

  item: {
    border: "1px solid #E7E9EB",
    display: "flex",
    alignItems: "flex-start",
    padding: "25px",
    borderRadius: "8px",
  },

  left: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  right: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: "30px",
  },

  name: {
    color: "#1A65FF",
    fontWeight: "bold",
    cursor: "pointer",
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "50px",
  },

  linkBtn: {
    color: "#1A65FF",
    border: "none",
    padding: "5px",
    marginLeft: "5px",
    minHeight: "unset",
    minWidth: "unset",
    fontSize: "13px",
    textDecoration: "underline",
  },

  link: {
    color: "#1A65FF",
    fontSize: "13px",
    cursor: "pointer",
    textDecoration: "none",
  },

  statusIcon: {
    width: "32px",
    height: "32px",
    background: "#F2F6FF",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  loaderContainer: {
    height: "100px",
    position: "relative",
    width: "100%",
  },

  iconButton: {
    color: "#71737B",
    padding: 0,
    width: "32px",
    minWidth: "32px",
    height: "32px",
    minHeight: "32px",
    marginLeft: "10px",
  },

  tabContainer: {
    width: "100%",
    padding: "0 25px",
    marginBottom: "18px",
    boxSizing: "border-box",
  },

  tab: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
  },

  tabButtonSelected: {
    color: "#1A65FF !important",
    fontWeight: "bold",
  },

  tabButton: {
    color: "#181819",
    listStyle: "none",
    padding: "0px 15px",
    margin: "8px 0px",
    fontSize: "13px",
    cursor: "pointer",
    transition: "120ms all linear",
    borderRight: "1px solid #D8DBDF",

    "&:hover": {
      fontWeight: "bold",
      color: "#1A65FF !important",
    },

    "&:first-child": {
      padding: "0px 15px 0px 0px",
    },

    "&:last-child": {
      border: "none",
    },
  },

  row: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    fontSize: "12px",
  },

  span: {
    marginRight: "10px",
    overflowWrap: "break-word",
  },
});

class ActivityPanel extends React.Component {
  state = {
    tab: ActivityPanel.TAB.ORDER.value,
    showOrderContractFilterDialog: false,
    filterValue: {
      order_contact_id: null,
    }
  };

  componentDidMount() {
    !this.props.isDemo && this.props.getOrderContacts();
    this.getFirstList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ownerType && prevProps.ownerType !== this.props.ownerType) {
      this.setState({
        filterValue: {
          order_contact_id: null,
        }
      }, () => {
        this.getFirstList();
      });
    }
  }

  loadMore = () => {
    if (this.props.isDemo) {
      this.props.togglePlanDialog()
    } else {
      let pageInfo = null;
      let getList = null;
      if (this.state.tab === ActivityPanel.TAB.ORDER.value) {
        pageInfo = this.props.pageInfoOrders;
        getList = this.props.getOrderList;
      } else if (this.state.tab === ActivityPanel.TAB.CALL.value) {
        pageInfo = this.props.pageInfoCalls;
        getList = this.props.getCallList;
      } else if (this.state.tab === ActivityPanel.TAB.REACTION.value) {
        pageInfo = this.props.pageInfoReactions;
        getList = this.props.getReactionList;
      }

      let query = this.filterValueToQuery();
      pageInfo && pageInfo.current_page < pageInfo.last_page && getList({
        ...query,
        paging: 1,
        per_page: ACTIVITIES_PER_PAGE,
        page: pageInfo.current_page + 1,
      }, false);
    }
  };

  handleChangeTab = (value) => {
    this.setState({
      tab: value,
    }, () => {
      this.getFirstList();
    });
  };

  handleFilter = (order_contact_id) => {
    this.setState({
      filterValue: {
        order_contact_id: order_contact_id === 0 ? null : order_contact_id,
      }
    }, () => {
      this.getFirstList();
    });
  };

  getFirstList = () => {
    let query = this.filterValueToQuery();
    let getListFunc = null;

    if (this.state.tab === ActivityPanel.TAB.ORDER.value) {
      getListFunc = this.props.getOrderList;
    } else if (this.state.tab === ActivityPanel.TAB.CALL.value) {
      getListFunc = this.props.getCallList;
    } else if (this.state.tab === ActivityPanel.TAB.REACTION.value) {
      getListFunc = this.props.getReactionList;
    }

    !this.props.isDemo && getListFunc && getListFunc({
      ...query,
      paging: 1,
      per_page: ACTIVITIES_PER_PAGE,
      page: 1,
    }, true);
  };

  filterValueToQuery = (filterValue = this.state.filterValue, ownerType = this.props.ownerType) => {
    let data = {};
    for (let property in filterValue) {
      if (property === 'order_contact_id' && filterValue && filterValue[property]) {
        data[property] = [filterValue[property]];
      } else {
        data[property] = filterValue[property];
      }
    }

    data["is_own"] = ownerType === OwnerType.OWN.value ? 'true' : 'false';

    return data;
  }

  toggleOrderContractFilterDialog = () => {
    this.setState({ showOrderContractFilterDialog: !this.state.showOrderContractFilterDialog });
  }

  groupByDate = () => {
    let list = null;
    if (this.state.tab === ActivityPanel.TAB.ORDER.value) {
      list = this.props.isDemo ? ActivityPanel.DEMO_DATA.ORDER : this.props.orderList;
    } else if (this.state.tab === ActivityPanel.TAB.CALL.value) {
      list = this.props.isDemo ? ActivityPanel.DEMO_DATA.CALL : this.props.callList;
    } else if (this.state.tab === ActivityPanel.TAB.REACTION.value) {
      list = this.props.isDemo ? ActivityPanel.DEMO_DATA.REACTION : this.props.reactionList;
    }

    let map = {};
    list && list.forEach((item) => {
      let key = moment(item.created_at).format("YYYY年MM月DD日");
      if (map.hasOwnProperty(key)) {
        map[key].push(item);
      } else {
        map[key] = [item];
      }
    });

    return map;
  }

  renderEmptyContent = () => {
    const { classes } = this.props;

    return (
      <div className={classes.content} style={{ padding: "50px 0px 100px 0px" }}>
        <Typography variant="subheading" style={{ fontWeight: "bold", marginBottom: "13px" }}>
          アクティビティはありません
        </Typography>
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          <Typography variant="body2">決裁者にレターを送りましょう</Typography>
          <MuiButton
            onClick={() => this.props.goTo("/executive-list")}
            color="primary"
            className={classes.linkBtn}
          >
            決裁者を検索
          </MuiButton>
        </div>
      </div>
    );
  };

  renderOrder = (order, i) => {
    const { classes } = this.props;
    const isOrderedLetter = order.letter_order ? true : false;
    const isOrderedFollowCall = order.follow_call_order ? true : false;
    const target = isOrderedLetter ? order.letter_order : order.follow_call_order;
    const count = target.order_addresses_count;
    const address = target.latest_order_address;

    const isScheduledAfter = isOrderedLetter ? isOrderScheduledAfter(order.letter_order.order_scheduled_at) : false;
    let orderStatusText;

    if (count === 0 || count === null) {
      if (isOrderedLetter && isOrderedFollowCall) {
        orderStatusText = "レターとフォローコールの注文データを作成中です。";
      } else if (isOrderedLetter) {
        orderStatusText = "レターの注文データを作成中です。";
      } else if (isOrderedFollowCall) {
        orderStatusText = "フォローコールの注文データを作成中です。";
      }
    } else if (isScheduledAfter) {
      orderStatusText = 'レターの注文が予約されました。';
    } else {
      if (isOrderedLetter && isOrderedFollowCall) {
        orderStatusText = count + "件のレターとフォローコールが注文されました。";
      } else if (isOrderedLetter) {
        orderStatusText = count + '通のレターが注文されました。';
      } else if (isOrderedFollowCall) {
        orderStatusText = count + '件のフォローコールが注文されました。';
      }
    }

    return (
      <div key={i} style={{ width: "100%" }}>
        <div className={classes.rect}></div>
        <div className={classes.item}>
          <div className={classes.left}>
            <Typography variant="body2" style={{ marginBottom: "15px" }}>
              {moment(order.created_at).format("HH:mm")}
            </Typography>
            <div className={classes.statusIcon} style={{ backgroundColor: "#F2F6FF" }}>
              {isOrderedLetter ? <SendLetter width={24} height={24} color="#6F9EFF" /> : <FollowCall width={12} height={12} color="#6F9EFF" />}
            </div>
          </div>

          <div className={classes.right}>
            <Typography variant="body2" style={{ marginBottom: "12px" }}>
              {isOrderedLetter ? "レター注文No." + order.letter_order.id : ""}{isOrderedLetter && isOrderedFollowCall ? " / " : ""}{isOrderedFollowCall ? "フォローコール注文No." + order.follow_call_order.id : ""}
            </Typography>

            <Typography
              variant="subheading"
              className={classes.name}
              onClick={() => {
                if (this.props.isDemo) {
                  this.props.togglePlanDialog();
                } else if (count === 0 || count === null) {
                  return;
                } else {
                  this.props.goTo(`/orders/${order.id}`);
                }
              }}
            >
              {`${orderStatusText}`}
            </Typography>

            <Typography className={classes.row} variant="body2">
              {isOrderedLetter && (
                <span className={classes.span}>{`注文担当者: ${target.order_contact ? target.order_contact.name : "-"
                  }`}</span>
              )}

              {target.order_scheduled_at && (
                <span className={classes.span}>{`注文予定日: ${moment(
                  target.order_scheduled_at
                ).format("YYYY年MM月DD日")}`}</span>
              )}

              {target.shipping_scheduled_at && (
                <span className={classes.span}>{`発送予定日: ${moment(
                  target.shipping_scheduled_at
                ).format("YYYY年MM月DD日")}`}</span>
              )}

              {address && (
                <span className={classes.span}>{`宛先: ${address.company} ${address.name
                  }${count > 1 ? `...他${count - 1}人` : ""}`}</span>
              )}
            </Typography>
          </div>
        </div>
      </div>
    );
  };

  renderReaction = (item, i) => {
    const { classes } = this.props;

    return (
      <div key={i}>
        <div className={classes.rect}></div>
        <div className={classes.item}>
          <div className={classes.left}>
            <Typography variant="body2" style={{ marginBottom: "15px" }}>
              {moment(item.created_at).format("HH:mm")}
            </Typography>
            <div className={classes.statusIcon} style={{ backgroundColor: "F7F2FF" }}>
              <Thunder width={24} height={24} color="#9B6FFF" />
            </div>
          </div>

          <div className={classes.right}>
            <Typography variant="body2" style={{ marginBottom: "12px" }}>
              レター注文No.{
                (
                  item.letter_order_address &&
                  item.letter_order_address.letter_order &&
                  item.letter_order_address.letter_order.id
                ) ? item.letter_order_address.letter_order.id : " -"} : QRコードが読み込まれました
            </Typography>

            <Typography
              variant="subheading"
              className={classes.name}
              onClick={() => {
                if (!this.props.isDemo) {
                  this.props.goTo(
                    `${item.executive_person_id
                      ? "/executive-list/" + item.executive_person_id
                      : "/house-list/" + item.address_id
                    }/timeline`,
                    // タイムラインから戻った際にダッシュボードのチーム/個人選択を復元するためstateを渡す
                    { pathname: "/order-dashboard", ownerType: this.props.ownerType }
                  );
                } else {
                  this.props.togglePlanDialog();
                }
              }}
            >
              {formatName(item.letter_order_address)}
            </Typography>

            <Typography variant="body2" style={{ fontSize: "12px" }}>
              {`${item.letter_order_address.branch ? "支店・部署:" + item.letter_order_address.branch : ""}  役職: ${item.letter_order_address.position ? item.letter_order_address.position : "-"
                }`}
            </Typography>
            {(this.props.isDemo || (
              item.letter_order_address &&
              item.letter_order_address.letter_order &&
              item.letter_order_address.letter_order.order_contact &&
              item.letter_order_address.letter_order.order_contact.name
            )) && (
                <Typography variant="body2" style={{ fontSize: "12px" }}>
                  注文担当者：{this.props.isDemo ? "山田太郎" : item.letter_order_address.letter_order.order_contact.name}
                </Typography>
              )}
          </div>
        </div>
      </div>
    );
  };

  renderCall = (item, i) => {
    const { classes } = this.props;

    return (
      <div key={i}>
        <div className={classes.rect}></div>
        <div className={classes.item}>
          <div className={classes.left}>
            <Typography variant="body2" style={{ marginBottom: "15px" }}>
              {moment(item.created_at).format("HH:mm")}
            </Typography>
            <div className={classes.statusIcon} style={{ backgroundColor: "#F2F6FF" }}>
              <FollowCall width={12} height={12} color="#6F9EFF" />
            </div>
          </div>

          <div className={classes.right}>
            <Typography variant="body2" style={{ marginBottom: "12px" }}>
              フォローコール注文No.{
                (
                  item.follow_call_order_address &&
                  item.follow_call_order_address.follow_call_order &&
                  item.follow_call_order_address.follow_call_order.id
                ) ? item.follow_call_order_address.follow_call_order.id : " -"} : フォローコールが開始されました
            </Typography>

            <Typography
              variant="subheading"
              className={classes.name}
              onClick={() => {
                if (!this.props.isDemo) {
                  this.props.goTo(
                    `${item.executive_person_id
                      ? "/executive-list/" + item.executive_person_id
                      : "/house-list/" + item.address_id
                    }/timeline`,
                    // タイムラインから戻った際にダッシュボードのチーム/個人選択を復元するためstateを渡す
                    { pathname: "/order-dashboard", ownerType: this.props.ownerType }
                  );
                } else {
                  this.props.togglePlanDialog();
                }
              }}
            >
              {formatName(item.follow_call_order_address)}
            </Typography>

            {(this.props.isDemo || (
              item.letter_order_address &&
              item.letter_order_address.letter_order &&
              item.letter_order_address.letter_order.order_contact &&
              item.letter_order_address.letter_order.order_contact.name
            )) && (
                <Typography variant="body2" style={{ fontSize: "12px" }}>
                  注文担当者：{this.props.isDemo ? "山田太郎" : item.letter_order_address.letter_order.order_contact.name}
                </Typography>
              )}
          </div>
        </div>
      </div>
    );
  };

  renderItems = () => {
    const { classes } = this.props;
    let isLoading = null;
    let renderItem = null;
    let pageInfo = null;

    if (this.state.tab === ActivityPanel.TAB.ORDER.value) {
      isLoading = this.props.isDemo ? false : this.props.isLoadingOrders;
      renderItem = this.renderOrder;
      pageInfo = this.props.isDemo ? ActivityPanel.DEMO_DATA.PAGE_INFO : this.props.pageInfoOrders;
    } else if (this.state.tab === ActivityPanel.TAB.CALL.value) {
      isLoading = this.props.isDemo ? false : this.props.isLoadingCalls;
      renderItem = this.renderCall;
      pageInfo = this.props.isDemo ? ActivityPanel.DEMO_DATA.PAGE_INFO : this.props.pageInfoCalls;
    } else if (this.state.tab === ActivityPanel.TAB.REACTION.value) {
      isLoading = this.props.isDemo ? false : this.props.isLoadingReactions;
      renderItem = this.renderReaction;
      pageInfo = this.props.isDemo ? ActivityPanel.DEMO_DATA.PAGE_INFO : this.props.pageInfoReactions;
    }

    let groupedData = this.groupByDate();
    if (Object.keys(groupedData).length === 0) {
      if (isLoading) {
        return (
          <div className={classes.loaderContainer}>
            <Loader />
          </div>
        );
      } else {
        return this.renderEmptyContent();
      }
    } else {
      return (
        <div className={classes.content}>
          {Object.keys(groupedData).map((key, i) => (
            <div key={i} className={classes.itemContainer}>
              <Typography
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  margin: "10px 0px",
                  color: "#181819",
                }}
              >
                {key}
              </Typography>
              {groupedData[key].map((item, j) => renderItem(item, j))}
            </div>
          ))}

          {(pageInfo &&
            pageInfo.current_page <
            pageInfo.last_page) && (
              <div className={classes.buttonContainer}>
                <Button
                  text="もっと見る"
                  type="line"
                  handleClickButton={this.loadMore}
                  size="large"
                  loading={isLoading}
                />
              </div>
            )}
        </div>
      );
    }
  }

  renderOrderContractFilterDialog = () => {
    if (this.state.showOrderContractFilterDialog) {
      return (
        <OrderContractFilterDialog
          isOpen={this.state.showOrderContractFilterDialog}
          toggleDialog={this.toggleOrderContractFilterDialog}
          orderContactId={this.state.filterValue.order_contact_id}
          save={this.handleFilter}
          orderContacts={this.props.orderContacts}
        />
      );
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography style={{ fontSize: "16px", fontWeight: "bold", color: "#181819" }}>
            アクティビティ
          </Typography>
          <ArrowToolTip text="条件で絞り込む">
            <IconButton
              className={classes.iconButton}
              onClick={this.toggleOrderContractFilterDialog}
            >
              <SettingIcon color="#71737B" />
            </IconButton>
          </ArrowToolTip>
        </div>

        <div className={classes.tabContainer}>
          <ul className={classes.tab}>
            {(Object.keys(ActivityPanel.TAB)).map((tab) => {
              // BDRプランではない場合、コールタブを非表示
              if (ActivityPanel.TAB[tab]["value"] === ActivityPanel.TAB.CALL.value && (!hasKLFollowCallBeenEnabled(this.props.user) && !this.props.isDemo)) {
                return null;
              }
              return (
                <li
                  key={ActivityPanel.TAB[tab]["value"]}
                  id={"activity-tab-" + ActivityPanel.TAB[tab]["value"]}
                  className={classNames(
                    classes.tabButton,
                    ActivityPanel.TAB[tab]["value"] === this.state.tab ? classes.tabButtonSelected : ""
                  )}
                  onClick={() => this.handleChangeTab(ActivityPanel.TAB[tab]["value"])}
                >
                  {ActivityPanel.TAB[tab]["name"]}
                </li>
              )
            })}
          </ul>
        </div>

        {this.renderItems()}
        {this.renderOrderContractFilterDialog()}
      </div>
    );
  }
}

ActivityPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  isDemo: PropTypes.bool,
  goTo: PropTypes.func.isRequired,
  ownerType: PropTypes.string,
  togglePlanDialog: PropTypes.func.isRequired,
  getOrderContacts: PropTypes.func.isRequired,
  orderContacts: PropTypes.array,
  user: PropTypes.object,
  // [注文]
  isLoadingOrders: PropTypes.bool,
  orderList: PropTypes.object,
  pageInfoOrders: PropTypes.object,
  getOrderList: PropTypes.func.isRequired,
  // [コール]
  isLoadingCalls: PropTypes.bool,
  callList: PropTypes.object,
  pageInfoCalls: PropTypes.object,
  getCallList: PropTypes.func.isRequired,
  // [リアクション]
  isLoadingReactions: PropTypes.bool,
  reactionList: PropTypes.object,
  pageInfoReactions: PropTypes.object,
  getReactionList: PropTypes.func.isRequired,
};

ActivityPanel.TAB = {
  "ORDER": { "value": 0, "name": "注文" },
  "CALL": { "value": 1, "name": "コール" },
  "REACTION": { "value": 2, "name": "リアクション" },
}

ActivityPanel.DEMO_DATA = {
  "ORDER": [
    {
      "id": 5,
      "created_at": "2020-07-19 20:59:47",
      "letter_order": {
        "id": 2,
        "order_addresses_count": 500,
        "latest_order_address": {
          "name": "坪根豊", "company": "株式会社ＪＴＢグローバルマーケティング＆トラベル"
        },
        "instructed_at": "2020-07-19 19:31:00",
        "order_contact": {
          "name": "山田太郎",
        },
        "shipping_scheduled_at": "2020-07-23 19:31:00",
        "created_at": "2020-07-19 20:59:47",
      }
    },
    {
      "id": 4,
      "created_at": "2020-07-11 20:59:47",
      "follow_call_order": {
        "id": 4,
        "order_addresses_count": 329,
        "latest_order_address": {
          "name": "笹川紗那", "company": "株式会社富士電業社"
        },
      },
      "letter_order": {
        "id": 1,
        "order_addresses_count": 329,
        "latest_order_address": {
          "name": "東田太志", "company": "西川ゴム工業株式会社"
        },
        "instructed_at": "2020-07-09 19:31:00",
        "order_contact": {
          "name": "山田太郎",
        },
        "shipping_scheduled_at": "2020-07-13 19:31:00",
        "created_at": "2020-07-09 20:59:47",
      },
    },
    {
      "id": 3,
      "created_at": "2020-07-04 16:23:47",
      "follow_call_order": {
        "id": 3,
        "order_addresses_count": 121,
        "latest_order_address": {
          "name": "荒井有紀", "company": "アイディック株式会社"
        },
      },
    },
    {
      "id": 2,
      "created_at": "2020-07-04 13:12:47",
      "follow_call_order": {
        "id": 2,
        "order_addresses_count": 11,
        "latest_order_address": {
          "name": "大石清次郎", "company": "日邦産業株式会社"
        },
      },
    },
    {
      "id": 1,
      "created_at": "2020-07-04 12:51:47",
      "follow_call_order": {
        "id": 1,
        "order_addresses_count": 5,
        "latest_order_address": {
          "name": "堀内照男", "company": "上海国際株式会社"
        },
      },
    },
  ],
  "CALL": [
    {
      "id": 7,
      "created_at": "2020-07-12 20:59:47",
      "follow_call_order_address": {
        "id": 1,
        "company": "笹川紗那",
        "name": "東武鉄道株式会社",
        "follow_call_order": {
          "id": 7,
        },
        "executive_person_id": 1,
      },
    },
    {
      "id": 7,
      "created_at": "2020-07-12 20:49:47",
      "follow_call_order_address": {
        "id": 2,
        "company": "日本生命保険相互会社",
        "name": "原口達哉",
        "follow_call_order": {
          "id": 7,
        },
        "executive_person_id": 1,
      },
    },
    {
      "id": 4,
      "created_at": "2020-07-09 20:19:47",
      "follow_call_order_address": {
        "id": 3,
        "company": "日本生命保険相互会社",
        "name": "木本国広",
        "follow_call_order": {
          "id": 4,
        },
        "executive_person_id": 1,
      },
    },
    {
      "id": 4,
      "created_at": "2020-07-09 20:09:47",
      "follow_call_order_address": {
        "id": 4,
        "company": "エーディーワイ株式会社",
        "name": "碓井勝子",
        "follow_call_order": {
          "id": 3,
        },
        "executive_person_id": 1,
      },
    },
    {
      "id": 3,
      "created_at": "2020-07-08 20:59:47",
      "follow_call_order_address": {
        "id": 5,
        "company": "株式会社ケーヒン",
        "name": "加川光徳",
        "follow_call_order": {
          "id": 3,
        },
        "executive_person_id": 1,
      },
    },
  ],
  "REACTION": [
    {
      "id": 5,
      "created_at": "2020-07-15 12:59:47",
      "type": 1,
      "status_label_type": TimelineLabelType.QR_CODE_REACTION.value,
      "letter_order_address": {
        "id": 1,
        "letter_order": {
          "id": 4,
          "order_contact": {
            "name": "山田太郎",
          },
        },
        "company": "株式会社フォーライフ",
        "name": "川瀬良男",
        "executive_person_id": 1,
        "position": "部長",
      },
    },
    {
      "id": 4,
      "created_at": "2020-07-15 11:59:47",
      "type": 1,
      "status_label_type": TimelineLabelType.QR_CODE_REACTION.value,
      "letter_order_address": {
        "id": 2,
        "letter_order": {
          "id": 3,
          "order_contact": {
            "name": "山田太郎",
          },
        },
        "company": "株式会社ケーヒン",
        "name": "加川光徳",
        "executive_person_id": 1,
        "branch": "関東",
        "position": "部長",
      },
    },
    {
      "id": 3,
      "created_at": "2020-07-14 13:59:47",
      "type": 1,
      "status_label_type": TimelineLabelType.QR_CODE_REACTION.value,
      "letter_order_address": {
        "id": 3,
        "letter_order": {
          "id": 3,
          "order_contact": {
            "name": "山田太郎",
          },
        },
        "company": "西川ゴム工業株式会社",
        "name": "東田太志",
        "executive_person_id": 1,
        "branch": "関東",
        "position": "執行役員",
      },
    },
    {
      "id": 2,
      "created_at": "2020-07-14 13:59:47",
      "type": 1,
      "status_label_type": TimelineLabelType.QR_CODE_REACTION.value,
      "letter_order_address": {
        "id": 4,
        "letter_order": {
          "id": 1,
          "order_contact": {
            "name": "山田太郎",
          },
        },
        "company": "株式会社ＪＴＢグローバルマーケティング＆トラベル",
        "name": "坪根豊",
        "executive_person_id": 1,
        "branch": "関東",
        "position": "情報企画室長",
      },
    },
    {
      "id": 1,
      "created_at": "2020-07-12 20:59:47",
      "type": 1,
      "status_label_type": TimelineLabelType.QR_CODE_REACTION.value,
      "letter_order_address": {
        "id": 5,
        "letter_order": {
          "id": 1,
          "order_contact": {
            "name": "山田太郎",
          },
        },
        "company": "株式会社ＪＴＢグローバルマーケティング＆トラベル",
        "name": "安田幹司",
        "executive_person_id": 1,
        "branch": "関東",
        "position": "中国・アジア営業部長、取締役",
      },
    },
  ],
  "PAGE_INFO": {
    "current_page": 1,
    "last_page": 2,
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    isDemo: state.accountSetting.showDemoData,
    orderContacts: state.accountSetting.orderContacts.toIndexedSeq().toArray(),
    // [注文]
    orderList: state.orderList.orderList,
    isLoadingOrders: state.orderList.isLoading,
    pageInfoOrders: state.orderList.pageInfo,
    // [コール]
    callList: state.orderDashboard.callList,
    isLoadingCalls: state.orderDashboard.isLoadingCalls,
    pageInfoCalls: state.orderDashboard.pageInfoCalls,
    // [リアクション]
    reactionList: state.orderDashboard.reactionList,
    isLoadingReactions: state.orderDashboard.isLoadingReactions,
    pageInfoReactions: state.orderDashboard.pageInfoReactions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // 注文
    getOrderList(data, overwrite) {
      dispatch(getOrderList(data, overwrite));
    },

    // コール
    getCallList(data, overwrite) {
      dispatch(actions.getCallList(
        {
          ...data,
          with_follow_call_order: true,
          with_follow_call_order_address: true,
          with_order_contact: true,
          is_first_follow_call: true,
        },
        overwrite)
      );
    },

    // リアクション
    getReactionList(data, overwrite) {
      dispatch(actions.getReactionList(
        {
          ...data,
          with_letter_order_address: true,
          with_order_contact: true,
          timeline_status: [TimelineStatusLabelType.QR_CODE_REACTION],
        },
        overwrite)
      );
    },

    // 注文担当者一覧を取得する
    getOrderContacts() {
      dispatch(getOrderContacts());
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityPanel));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/panels/ActivityPanel.jsx